import { Row, Col, Form } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import FilePicker from "../FilePicker";
import SectionSeparator from "../SectionSeparator";

const RequiredDocumentsStep = ({ ctx }) => {
  const {
    formData,
    errors,
    child_eid_page,
    setChildEidPage,
    child_passport,
    setChildPassport,
    birth_certcopy,
    setBirthCertcopy,
    vaccination_copy,
    setVaccinationCopy,
    prev_school_rep_doc,
    setPrevSchoolRepCopy,
    family_card_doc,
    setFamilyIDCopy,
    document1,
    setSponsorIqamaCopy,
    father_passport_attachment,
    setFatherPassportAttachment,
    mother_id_attachment,
    setMotherIdAttachment,
    mother_passport_attachment,
    setMotherPassportAttachment,
  } = ctx;

  return (
    <>
      {/* Child's Documents */}
      <SectionSeparator title="title.child_documents" />
      <Row>
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>
              <FormattedMessage id="emirates_id_front" />
            </Form.Label>
            <FilePicker
              name="child_eid_page"
              file={child_eid_page}
              setFile={setChildEidPage}
              admissionID={formData.admission_id}
              height={200}
              uploadable
            />
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>
              <FormattedMessage id="passport" />
            </Form.Label>
            <FilePicker
              name="child_passport"
              file={child_passport}
              setFile={setChildPassport}
              admissionID={formData.admission_id}
              height={200}
              uploadable
            />
          </Form.Group>
        </Col>
        {/* <Col md={3}>
                        <Form.Group className="mb-3">
                          <Form.Label>
                            <FormattedMessage id="visa" />
                          </Form.Label>
                          <FilePicker
                            name="visa_page"
                            file={visa_page}
                            setFile={setVisaPage}
                            admissionID={formData.admission_id}
                            height={200}
                            uploadable
                          />
                        </Form.Group>
                      </Col> */}
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>
              <FormattedMessage id="birth_certificate" />
            </Form.Label>
            <FilePicker
              name="birth_certcopy"
              file={birth_certcopy}
              setFile={setBirthCertcopy}
              admissionID={formData.admission_id}
              height={200}
              uploadable
            />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>
              <FormattedMessage id="immunization_record" />
            </Form.Label>
            <FilePicker
              name="vaccination_copy"
              file={vaccination_copy}
              setFile={setVaccinationCopy}
              admissionID={formData.admission_id}
              height={200}
              uploadable
            />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>
              <FormattedMessage id="attended_prev_school_report" />
            </Form.Label>
            <FilePicker
              name="prev_school_rep_doc"
              file={prev_school_rep_doc}
              setFile={setPrevSchoolRepCopy}
              admissionID={formData.admission_id}
              height={200}
              uploadable
            />
          </Form.Group>
        </Col>
      </Row>

      {/* Sponsor's Documents */}
      <SectionSeparator title="title.sponsor_documents" />
      <Row>
        {/* <Col md={3}>
                        <Form.Group className="mb-3">
                          <Form.Label>
                            <FormattedMessage id="emirates_id_front" />
                          </Form.Label>
                          <FilePicker
                            name="father_id_attachment"
                            file={father_id_attachment}
                            setFile={setFatherIdAttachment}
                            admissionID={formData.admission_id}
                            height={200}
                            uploadable
                          />
                        </Form.Group>
                      </Col> */}
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>
              <FormattedMessage id="passport" />
            </Form.Label>
            <FilePicker
              name="father_passport_attachment"
              file={father_passport_attachment}
              setFile={setFatherPassportAttachment}
              admissionID={formData.admission_id}
              height={200}
              uploadable
              error={errors?.father_passport_attachment}
            />
          </Form.Group>
        </Col>
        {/* <Col md={3}>
                        <Form.Group className="mb-3">
                          <Form.Label>
                            <FormattedMessage id="visa" />
                          </Form.Label>
                          <FilePicker
                            name="father_visa_attachment"
                            file={father_visa_attachment}
                            setFile={setFatherVisaAttachment}
                            admissionID={formData.admission_id}
                            height={200}
                            uploadable
                            error={errors?.father_visa_attachment}
                          />
                        </Form.Group>
                      </Col> */}
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>
              <FormattedMessage id="sponsor_iqama_copy" />
            </Form.Label>
            <FilePicker
              name="document1"
              file={document1}
              setFile={setSponsorIqamaCopy}
              admissionID={formData.admission_id}
              height={200}
              uploadable
              error={errors?.document1}
            />
          </Form.Group>
        </Col>
        {/* <Col md={3}>
                        <Form.Group className="mb-3">
                          <Form.Label>
                            <FormattedMessage id="sponsor_noc_copy" />
                          </Form.Label>
                          <FilePicker
                            name="sponsor_noc"
                            file={sponsor_noc}
                            setFile={setSponsorNocCopy}
                            admissionID={formData.admission_id}
                            height={200}
                            uploadable
                          />
                        </Form.Group>
                      </Col> */}
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>
              <FormattedMessage id="family_id_card" />
            </Form.Label>
            <FilePicker
              name="family_card_doc"
              file={family_card_doc}
              setFile={setFamilyIDCopy}
              admissionID={formData.admission_id}
              height={200}
              uploadable
            />
          </Form.Group>
        </Col>
      </Row>

      {/* Spouse's Documents */}
      <SectionSeparator title="title.spouse_documents" />
      <Row>
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>
              <FormattedMessage id="mother_id" />
            </Form.Label>
            <FilePicker
              name="mother_id_attachment"
              file={mother_id_attachment}
              setFile={setMotherIdAttachment}
              admissionID={formData.admission_id}
              height={200}
              uploadable
              error={errors?.mother_id_attachment}
            />
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>
              <FormattedMessage id="passport" />
            </Form.Label>
            <FilePicker
              name="mother_passport_attachment"
              file={mother_passport_attachment}
              setFile={setMotherPassportAttachment}
              admissionID={formData.admission_id}
              height={200}
              uploadable
              error={errors?.mother_passport_attachment}
            />
          </Form.Group>
        </Col>
        {/* <Col md={3}>
                        <Form.Group className="mb-3">
                          <Form.Label>
                            <FormattedMessage id="visa" />
                          </Form.Label>
                          <FilePicker
                            name="mother_visa_attachment"
                            file={mother_visa_attachment}
                            setFile={setMotherVisaAttachment}
                            admissionID={formData.admission_id}
                            height={200}
                            uploadable
                          />
                        </Form.Group>
                      </Col> */}
      </Row>
    </>
  );
};

export default RequiredDocumentsStep;
